import { ChangeDetectionStrategy, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EtiquetaContent } from '../../types/etiqueta-content';

@Component({
  selector: 'st-default-etiqueta-content',
  templateUrl: './default-etiqueta-content.component.html',
  styleUrls: ['./default-etiqueta-content.component.scss'],
  providers: [{ 
    provide: EtiquetaContent, 
    useExisting: DefaultEtiquetaContentComponent
  }],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultEtiquetaContentComponent extends EtiquetaContent implements OnInit {

  @Input() nombreEtiqueta: string;

  valor: string;

  constructor() { super() }

  ngOnInit(): void { }

  obtenerNombre(): string {
    return this.nombreEtiqueta;
  }

}
